export default () => {

    const whoAmI = async (email?: any) => {
        const response = await fetch(`${import.meta.env.VITE_APP_ENV_SERVER}/lpi-service/who-am-i-cognito?email=${encodeURIComponent(email)}`, {
            method: 'GET',
        })
        return await response.json()
    }

    return {
        whoAmI
    }
}
